import {
  AfterContentInit, Directive, ElementRef, EventEmitter, Inject, Input, OnDestroy, Output, PLATFORM_ID,
  Renderer2
} from "@angular/core";
import {isPlatformBrowser} from "@angular/common";
// import { hostElement } from "@angular/core/src/render3/instructions";

@Directive({
  selector: '[image-loader]'
})
export class ImageLoaderDirective implements AfterContentInit, OnDestroy {
  private nativeElement: HTMLElement;
  private cancelOnError: Function;
  private cancelOnLoad: Function;
  private largeImage;

  @Input() fallback: string = '';
  @Input() url: string;
  @Input() size: number;
  @Output() emitOnError: EventEmitter<any> = new EventEmitter();

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef,
    private renderer: Renderer2){
  }

  ngAfterContentInit(){
      this.registerEvents();
  }

  registerEvents(){
      this.nativeElement = this.el.nativeElement;
      this.onError = this.onError.bind(this);
      this.onLoad = this.onLoad.bind(this);
      this.cancelOnError = this.renderer.listen(this.nativeElement, 'error', this.onError);
      this.cancelOnLoad = this.renderer.listen(this.nativeElement, 'load', this.onLoad);
  }

  loadLargeImage(url){
      this.largeImage = new Image();
      this.largeImage.src = url;
      this.largeImage.onload = () => {
        this.renderer.setAttribute(this.nativeElement, 'src', this.largeImage.src);
        this.renderer.addClass(this.nativeElement,"hr");
      }
  }

  private onError(){
      if(this.nativeElement.getAttribute('src') !== this.fallback){
          this.renderer.setAttribute(this.nativeElement, 'src', this.fallback);
          this.emitOnError.emit();
      }else{
          this.removeOnLoadEvent();
      }
  }

  private onLoad(){
      this.removeOnLoadEvent();
      this.loadLargeImage(this.url + '?w=' + this.size);
  }

  private removeErrorEvent() {
      if (this.cancelOnError) {
          this.cancelOnError();
      }
  }

  private removeOnLoadEvent() {
      if (this.cancelOnLoad) {
          this.cancelOnLoad();
      }
  }

  ngOnDestroy(){
      this.removeErrorEvent();
      this.removeOnLoadEvent();
  }
}


// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/directive/image-loader.directive.ts